import styled from 'styled-components';

export const PreviewContainer = styled.div`
  /* margin: 2rem 0; */
  /* text-align: left; */
  width: 100%;
`;

export const PreviewButton = styled.button`
  background: ${({ theme }) => theme.colors.yellow6};
  color: ${({ theme }) => theme.colors.grey4};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 0.7rem 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  cursor: pointer;
  transition:
    background 0.2s,
    transform 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.yellow5};
    color: ${({ theme }) => theme.colors.grey7};
    transform: translateY(-2px) scale(1.03);
  }
`;

export const EmailPreviewBox = styled.div`
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 2rem;
  width: 100%;
  box-shadow: 0 2px 12px #0001;
  /* border: 5px solid blue; */
  h1 {
    font-size: 2rem;
    color: #343434;
    font-family: Georgia, serif;
    margin-bottom: 0.5rem;
    padding: 0 0.5rem;
    font-weight: bold;
  }

  .month {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .block {
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    h2 {
      font-size: 1.2rem;
      color: #343434;
      font-family: Georgia, serif;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 1rem;
      color: #494646;
      margin-bottom: 0;
    }
  }
`;
